var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemberHelpWideFlange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-3, .cls-4, .cls-5, .cls-6 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: silver;\r\n      }\r\n\r\n      .cls-3, .cls-4, .cls-5, .cls-6 {\r\n        stroke: #000;\r\n        stroke-linecap: round;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke-width: 1.34px;\r\n      }\r\n\r\n      .cls-4 {\r\n        stroke-width: 0.27px;\r\n      }\r\n\r\n      .cls-5 {\r\n        stroke-width: 0.47px;\r\n      }\r\n\r\n      .cls-6 {\r\n        stroke-width: 0.8px;\r\n      }\r\n\r\n      .cls-7 {\r\n        font-size: 8.82px;\r\n        font-family: ArialMT, Arial;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MemberHelpWideFlange") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Boundary"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 256,
    height: 200
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "MemberWideFlange"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "158.21 152.73 158.21 145.97 132.48 145.97 130.94 145.75 129.59 145.19 128.41 144.27 127.48 143.08 126.93 141.74 126.71 140.2 126.71 60.33 126.93 58.79 127.48 57.44 128.41 56.26 129.59 55.33 130.94 54.78 132.48 54.56 158.21 54.56 158.21 47.79 90.87 47.79 90.87 54.56 116.6 54.56 118.14 54.78 119.48 55.33 120.67 56.26 121.59 57.44 122.15 58.79 122.37 60.58 122.37 140.2 122.15 141.74 121.59 143.08 120.67 144.27 119.48 145.19 118.14 145.75 116.6 145.97 90.87 145.97 90.87 152.73 132.48 152.73 158.21 152.73"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 122.37,
    y1: 60.32,
    x2: 122.37,
    y2: 140.2
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "122.37 140.2 122.15 141.74 121.59 143.08 120.67 144.27 119.48 145.19 118.14 145.75 116.6 145.97"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 116.6,
    y1: 145.97,
    x2: 90.87,
    y2: 145.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 90.87,
    y1: 145.97,
    x2: 90.87,
    y2: 152.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 90.87,
    y1: 152.73,
    x2: 158.21,
    y2: 152.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 158.21,
    y1: 152.73,
    x2: 158.21,
    y2: 145.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 158.21,
    y1: 145.97,
    x2: 132.48,
    y2: 145.97
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "132.48 145.97 130.94 145.75 129.59 145.19 128.41 144.27 127.48 143.08 126.93 141.74 126.71 140.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 126.71,
    y1: 140.2,
    x2: 126.71,
    y2: 60.32
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "126.71 60.33 126.93 58.79 127.48 57.44 128.41 56.26 129.59 55.33 130.94 54.78 132.48 54.56"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 132.48,
    y1: 54.56,
    x2: 158.21,
    y2: 54.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 158.21,
    y1: 54.56,
    x2: 158.21,
    y2: 47.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 158.21,
    y1: 47.79,
    x2: 90.87,
    y2: 47.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 90.87,
    y1: 47.79,
    x2: 90.87,
    y2: 54.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 90.87,
    y1: 54.56,
    x2: 116.6,
    y2: 54.56
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "116.6 54.56 118.14 54.78 119.48 55.33 120.67 56.26 121.59 57.44 122.15 58.79 122.37 60.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M425.33,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M224.8,0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 72.94,
    y1: 43.61,
    x2: 72.94,
    y2: 156.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 72.94,
    y1: 152.73,
    x2: 70.85,
    y2: 150.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 72.94,
    y1: 152.73,
    x2: 75.03,
    y2: 154.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 72.94,
    y1: 152.73,
    x2: 68.76,
    y2: 152.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 72.94,
    y1: 152.73,
    x2: 86.69,
    y2: 152.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 72.94,
    y1: 47.79,
    x2: 70.85,
    y2: 45.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 72.94,
    y1: 47.79,
    x2: 75.03,
    y2: 49.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 72.94,
    y1: 47.79,
    x2: 68.76,
    y2: 47.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 72.94,
    y1: 47.79,
    x2: 86.69,
    y2: 47.79
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(70.24 111.87) rotate(-90)"
  }, "Depth"), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 86.69,
    y1: 29.81,
    x2: 162.39,
    y2: 29.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 158.21,
    y1: 29.81,
    x2: 156.12,
    y2: 31.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 158.21,
    y1: 29.81,
    x2: 160.3,
    y2: 27.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 158.21,
    y1: 29.81,
    x2: 158.21,
    y2: 25.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 158.21,
    y1: 29.81,
    x2: 158.21,
    y2: 43.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 90.87,
    y1: 29.81,
    x2: 88.78,
    y2: 31.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 90.87,
    y1: 29.81,
    x2: 92.96,
    y2: 27.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 90.87,
    y1: 29.81,
    x2: 90.87,
    y2: 25.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 90.87,
    y1: 29.81,
    x2: 90.87,
    y2: 43.61
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(113.13 27.12)"
  }, "Width"), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 171.96,
    y1: 43.61,
    x2: 171.96,
    y2: 58.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 171.96,
    y1: 54.56,
    x2: 169.87,
    y2: 52.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 171.96,
    y1: 54.56,
    x2: 174.05,
    y2: 56.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 171.96,
    y1: 54.56,
    x2: 176.14,
    y2: 54.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 171.96,
    y1: 54.56,
    x2: 162.39,
    y2: 54.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 171.96,
    y1: 47.79,
    x2: 169.87,
    y2: 45.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 171.96,
    y1: 47.79,
    x2: 174.05,
    y2: 49.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 171.96,
    y1: 47.79,
    x2: 176.14,
    y2: 47.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 171.96,
    y1: 47.79,
    x2: 162.39,
    y2: 47.79
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(179.82 51.13)"
  }, "Flange"), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(179.68 60.07)"
  }, "thickness"), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 118.19,
    y1: 98.56,
    x2: 130.89,
    y2: 98.56
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "124.54 98.56 124.99 96.15 126.29 93.98 128.32 92.26 130.87 91.15 133.7 90.77"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 126.71,
    y1: 98.56,
    x2: 124.62,
    y2: 100.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 126.71,
    y1: 98.56,
    x2: 128.8,
    y2: 96.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 126.71,
    y1: 98.56,
    x2: 126.71,
    y2: 94.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 126.71,
    y1: 98.56,
    x2: 126.71,
    y2: 99.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 122.37,
    y1: 98.56,
    x2: 120.28,
    y2: 100.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 122.37,
    y1: 98.56,
    x2: 124.46,
    y2: 96.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 122.37,
    y1: 98.56,
    x2: 122.37,
    y2: 94.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 122.37,
    y1: 98.56,
    x2: 122.37,
    y2: 99.78
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(133.7 94.04)"
  }, "Web thickness"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberHelpWideFlange);
export default __webpack_public_path__ + "static/media/MemberHelpWideFlange.f9c9d44b3c3c7035005f92797266eaf3.svg";
export { ForwardRef as ReactComponent };